<div class="content">
  <mat-icon class="close" mat-dialog-close>close</mat-icon>
  <div class="part1">热销总榜 TOP 6</div>
  <div class="divider"></div>
  <div class="part3">
    <div class="item" *ngFor="let item of data; let i = index">
      <div class="left">{{ i + 1 }}</div>
      <div class="middle">
        <app-image [fileid]="item.icon"></app-image>
        <span class="name">{{ item.name }}</span>
      </div>
      <div class="right">
        <span class="price">￥{{ item.price }}</span>
        <div class="btn" (click)="openPlatform(item)">上车</div>
      </div>
    </div>
  </div>
</div>
